import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    user: null,
    isAuthenticated: localStorage.getItem("accessToken") ? true : false,
    accessToken: localStorage.getItem("accessToken") || null,
    loading: false,
    error: null
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setUser: (state, action) => {
            console.log('action: ', action);
            console.log('state: ', state);
            state.user = action.payload.data.staff;
            state.isAuthenticated = true;
            state.accessToken = action.payload.data.accessToken;
            localStorage.setItem("accessToken", action.payload.data.accessToken);
        },

        logout(state) {
            localStorage.removeItem("accessToken");
            state.user = null;
            state.isAuthenticated = false;
            state.accessToken = null;
        },

        updateUserDetails: (state, action) => {
          state.user = { ...state.user, ...action.payload };
      },
        resetAuthState: (state) => {
            state.isAuthenticated = localStorage.getItem("accessToken") ? true : false;
            state.accessToken = localStorage.getItem("accessToken") || null;
            state.user = null;
            state.loading = false;
            state.error = null;
        },
        resetAuth: () => initialState,
    },
});

export const { setUser, logout,updateUserDetails, resetAuthState,resetAuth } = authSlice.actions;
export default authSlice.reducer;